import httpClient from "./httpClient";

const END_POINT = "/api";
const getEventsAgent = (endDate) =>
    httpClient.get(END_POINT + "/getEventsAgent/" + endDate);
export { getEventsAgent };
